import { render, staticRenderFns } from "./ProductsInStockSidebar.vue?vue&type=template&id=e2985c32&scoped=true"
import script from "./ProductsInStockSidebar.vue?vue&type=script&lang=js"
export * from "./ProductsInStockSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProductsInStockSidebar.vue?vue&type=style&index=0&id=e2985c32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2985c32",
  null
  
)

export default component.exports